/// <reference path="../../../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />

import * as React from 'react';
import { AppButton, AppProgressBar } from '../../components';
import { Label, Link, Image, IButton } from 'office-ui-fabric-react';
import { RouteComponentProps } from 'react-router-dom';
import { TranscriptionRoutePathNames } from '../../routes';
import { LogEvents } from '../../../utils/LogEvents';
import { AppLayoutSettings, getMainPageStyles } from '../common.styles';
import { getBottomLabelStyles, getFileInputStyles, getEnglishOnlyLabelStyles } from './Landing.styles';
import { LEARN_MORE_URL, ACCEPTED_FILE_FORMATS_FOR_UPLOAD } from '../../../AppConstants';
import { AppAuthenticationProviderContext } from '../../context';
import { SetForegroundTaskInStore } from '../../actions/LoadingActions';
import { FileUploadForegroundTask } from '../../../backend/FileUploadForegroundTask';
import { IsFileUploadEnabled, HostAppSettings, HostAppSettingName } from '../../../backend/office-js/HostAppSettings';
import { TranscriptionMonthlyQuota } from '../../../backend/TranscriptionMonthlyQuota';
import { RenderToPaneKeys } from '../telemetry/RenderToPaneKeys';
import { DurationMeasureType } from '../../../backend/interfaces/ILogEvent';
import { AddTooltipToElement } from '../../components/Tooltip/AddTooltipToElement';
import { LicensePopup } from '../../components/Popups/LicensePopup';

export class Landing extends React.PureComponent<RouteComponentProps> {
  static contextType = AppAuthenticationProviderContext;

  private recordButtonRef = React.createRef<IButton>();
  private fileInputref = React.createRef<HTMLInputElement>();

  private UploadFile(file: File) {
    LogEvents.RenderToPane.Start([{ key: RenderToPaneKeys.TriggerReason, value: "Upload audio" }]);
    LogEvents.RenderToPane.BeginDurationMeasure(DurationMeasureType.Normal, RenderToPaneKeys.DurationSecs);
    SetForegroundTaskInStore(new FileUploadForegroundTask(file, this.context, this.props.history, this.props.location.state.realTimeTranscriptionConnection));
    if (this.props.location.state.audioBackup != null) {
      this.props.location.state.audioBackup.Close();
      this.props.location.state.audioBackup = null;
    }

    this.props.location.state.realTimeTranscriptionConnection = null;
    this.props.history.replace(TranscriptionRoutePathNames.Loading);
  }

  public componentDidMount() {
    this.recordButtonRef.current.focus();
  }

  public render() {
    const recordButtonID = "recordButton";
    const uploadButtonID = "uploadButton";

    const usedMinutes = TranscriptionMonthlyQuota.GetInstance().GetCachedUsedMinutes();
    const totalAvailableMinutes = TranscriptionMonthlyQuota.GetInstance().GetAvailableUploadMinutesPerMonth();
    const percentTimeUsed = TranscriptionMonthlyQuota.GetInstance().GetCachedPercentTimeUsed();
    const timeUsedLabel = usedMinutes + "/" + totalAvailableMinutes + TranscriptionStrings.LandingPageTranscriptionTimeUsedLabel;

    const styles = getMainPageStyles();

    const _onRecordClicked = (): void => {
      LogEvents.ServiceLiveSpeechToText.Start();
      this.props.history.replace(TranscriptionRoutePathNames.Recording, {realTimeTranscriptionConnection: this.props.location.state.realTimeTranscriptionConnection, audioBackup: this.props.location.state.audioBackup});
    };

    const _onUploadClicked = (): void => {
      this.fileInputref.current.click();
    };

    const _onFileInput = async (event) => {
      LogEvents.ServiceLiveSpeechToText.Start();
      this.UploadFile(event.target.files[0]);
    };

    const enableUpload = percentTimeUsed < 1.0; // '1.0' represents 100 percent
    const uploadButton = <AppButton type={'AppButtonProps'} id={uploadButtonID} text={TranscriptionStrings.LandingPageUploadButtonLabel} onExecute={_onUploadClicked} disabled={!enableUpload}/>

    return (
      <div style={AppLayoutSettings.AppCommonStyles.getPageRootContainersCSSProperties()}>
        { IsFileUploadEnabled() ? (<input type="file" ref={this.fileInputref} style={getFileInputStyles()} onInput={_onFileInput} accept={ACCEPTED_FILE_FORMATS_FOR_UPLOAD}></input>) : null }
        <div style={{ flexGrow: 1 }}>
          <div className={styles.labelContainer}>
            { IsFileUploadEnabled() ?
              (<div>
                <Label styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>{TranscriptionStrings.TranscriptionPaneDescriptionLabelWithUpload}</Label>
                <Label styles={getEnglishOnlyLabelStyles()}>{TranscriptionStrings.TranscriptionOnlyInEnglishLabel}</Label>
              </div>)
              :
              (<Label styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>{TranscriptionStrings.TranscriptionPaneDescriptionLabel}</Label>)
            }
          </div>
          <div className={styles.buttonContainer}>
            { IsFileUploadEnabled() ?
              (
                (enableUpload) ?
                  uploadButton
                  :
                  AddTooltipToElement(uploadButton, TranscriptionStrings.LandingPageUploadButtonLimitCrossedLabel)
              )
              : null
            }
            <AppButton buttonRef={this.recordButtonRef} type={'AppButtonProps'} id={recordButtonID} text={TranscriptionStrings.LandingPageRecordButtonLabel} onExecute={_onRecordClicked} />
          </div>
          <div className={styles.imageContainer}>
            <Image alt="" src={require('../../../../assets/' + AppLayoutSettings.AppImageParams.cartoonImageName)} width={AppLayoutSettings.AppImageParams.cartoonImageWidthPx} height={AppLayoutSettings.AppImageParams.cartoonImageHeightPx} />
          </div>

        </div>
        { IsFileUploadEnabled() ?
          (<div className={styles.bottomLabelContainer}>
            <Label styles={getBottomLabelStyles()}>{timeUsedLabel}</Label>
            <div className={styles.progressContainer}>
              <AppProgressBar type={'AppProgressBarProps'} barHeight={3} percentComplete={percentTimeUsed} />
            </div>
            <Link styles={AppLayoutSettings.AppCommonStyles.getLearnMoreLinkStyles()} href={LEARN_MORE_URL} target="_blank">{TranscriptionStrings.TranscriptionPaneLearnLabel}</Link>
          </div>)
        :
          (<div className={styles.bottomLabelContainer}>
            <Label styles={getBottomLabelStyles()}>{TranscriptionStrings.TranscriptionOnlyInEnglishLabel}</Label>
          </div>)
        }
        {
          HostAppSettings.IsSettingTrue(HostAppSettingName.IsFreemiumUpsellEnabled) ?
            (
              <LicensePopup />
            )
          :
            (
              null
            )
        }
      </div>
    );
  }
}